{
    "404": "Ah non ! Nous avons fouillé la mer et nous ne trouvons pas votre page !"
}
